import React, { useContext, useEffect, useState } from "react";
import { Box, Modal, Stack, Button } from "@mui/material";
import { dashboardContext } from "../../Dashboard";
import { NormalText, SmallHeadline } from "../../../../components/TextParts";
import NonIconButton from "../../../../components/NonIconButton";
import BaseApi from "../../../../functions/axios";
import { useNavigate } from "react-router-dom";

export default function ConditionDialog() {
  const { conditions } = useContext(dashboardContext);
  const [isOpen, setIsOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") return;
    setIsOpen(false);
  };

  const handleDisagree = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const res = await BaseApi.post("post_conditions", {
        condition_id: conditions?.id,
        condition_check: false,
      });
      if (res?.status === 200) {
        navigate("/");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleAgree = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const res = await BaseApi.post("post_conditions", {
        condition_id: conditions?.id,
        condition_check: true,
      });
      if (res?.status === 200) {
        setIsOpen(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (conditions?.conditions) {
      setIsOpen(true);
    }
  }, [conditions]);

  return (
    <Box>
      <Modal
        open={isOpen}
        onClose={handleClose}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box
          sx={{
            width: "80vw",
            height: "80vh",
            bgcolor: "white",
            overflowY: "auto",
            maxWidth: "1000px",
            px: 8,
            py: 5,
          }}
        >
          <SmallHeadline text="約款" />
          <NormalText text={conditions?.conditions} />
          <Stack spacing={2} sx={{ mt: "40px" }}>
            <Button
              variant="contained"
              disabled={submitting}
              onClick={handleDisagree}
              color="inherit"
              sx={{
                borderRadius: "25px",
                color: "black",
                fontSize: "14px",
                fontWeight: "bold",
                py: "10px",
                px: "20px",
                width: "100%",
              }}
            >
              同意しない
            </Button>
            <NonIconButton title="同意する" clickEvent={handleAgree} disabled={submitting} />
          </Stack>
        </Box>
      </Modal>
    </Box>
  );
}